export default __webpack_public_path__ + "static/media/e1.e7ffda1d.jpg";